/* @flow */
import Store from 'lib/Store';
import { ActionTypes as ChatActionTypes } from 'chat/constants/ChatConstants';
import ChatMessage, { chatMessageFactory } from 'entities/ChatMessage';
import ChatMessageDelivery from 'entities/ChatMessageDelivery';
import { ActionTypes as GroupActionTypes } from 'groups/constants/GroupConstants';
import GroupMessageDelivery from 'entities/GroupMessageDelivery';
import MessageDeliveries from 'collections/MessageDeliveries';
import { PushEvents } from 'pusher/PusherConstants';

export class Marker {
  updatedAt: string;
  readSeq: number;

  constructor({
    read_seq: readSeq,
    updated_at: updatedAt,
  }: {
    read_seq: number,
    updated_at: string,
  }) {
    this.readSeq = readSeq;
    this.updatedAt = updatedAt;
  }
}

// Note: Flux stores are now a DEPRECATED pattern. See docs/GraphQL.md
class DeliveryStore extends Store {
  getInitialState() {
    return {
      deliveries: new MessageDeliveries(),
      markers: {},
    };
  }

  getDeliveryByMessageId(id) {
    /* We need to clone the deliveries so that containers
     * know to rerender when performing a shallow comparison
     * of the otherwise unchanged backbone collection.
    */
    const delivery = this.state.deliveries.findWhereMessageId(id);
    return delivery && delivery.clone();
  }

  storeDeliveries(deliveries) {
    this.state.deliveries.add(deliveries);
  }

  getMarkerForStream(streamId) {
    return this.state.markers[streamId];
  }

  storeMarkersForStream(streamId, markers) {
    this.state.markers[streamId] = Object.assign(this.state.markers[streamId] || {}, markers);
  }

  handleDispatch(action: Object): void {
    let delivery;
    let chatMessages;

    switch (action.type) {
      case GroupActionTypes.LIST_GROUP_MESSAGES: {
        const deliveries = action.messages.map(groupMessage => {
          return GroupMessageDelivery.createFromGroupMessage(groupMessage);
        });

        this.storeDeliveries(deliveries);
        this.emitChange();
        break;
      }
      case GroupActionTypes.SEND_GROUP_MESSAGE:
        delivery = GroupMessageDelivery.createFromGroupMessage(action.message);
        this.storeDeliveries([delivery]);
        this.emitChange();
        break;
      case ChatActionTypes.SENT_MESSAGE:
        delivery = ChatMessageDelivery.createFromChatMessage(action.message);
        this.storeDeliveries([delivery]);
        this.emitChange();
        break;
      case ChatActionTypes.SEND_MESSAGE:
        delivery = ChatMessageDelivery.createFromChatMessage(action.message);
        delivery.setReadSummaryState('pending_initial_ack');
        this.storeDeliveries([delivery]);
        this.emitChange();
        break;
      case ChatActionTypes.LOAD_CHAT_MESSAGES: {
        // filter only the ChatMessage, no GapChatMessage ect.
        chatMessages = action.messages.filter(message => {
          return message instanceof ChatMessage;
        });

        // Create the deliveries from ChatMessages.
        const deliveries = chatMessages.map(chatMessage => {
          return ChatMessageDelivery.createFromChatMessage(chatMessage);
        });

        this.storeDeliveries(deliveries);
        this.emitChange();
        break;
      }
      case PushEvents.CHANGESET_CREATE_CHAT_MESSAGE: {
        const deliveries = action.changes
          .map(change => chatMessageFactory(change.content))
          .filter(message => message instanceof ChatMessage)
          .map(message => ChatMessageDelivery.createFromChatMessage(message));

        if (deliveries.length > 0) {
          this.storeDeliveries(deliveries);
          this.emitChange();
        }
        break;
      }
      case PushEvents.CHANGESET_UPDATE_DELIVERY_UPDATES: {
        const deliveries = action.changes.map(change =>
          ChatMessageDelivery.fromJSON(change.content)
        );
        this.storeDeliveries(deliveries);
        this.emitChange();
        break;
      }
      case PushEvents.CHANGESET_UPDATE_CHAT_MARKER: {
        action.changes.forEach(change => {
          this.storeMarkersForStream(change.uuid, new Marker(change.content.markers));
        });
        this.emitChange();
        break;
      }
      default:
        break;
    }
  }
}

export default new DeliveryStore();
